import { Typography } from 'shared/ui'
import styles from './styles.module.scss'

export const packageTooltipDesc = (
  <div className={styles.tooltipDesc}>
    <Typography ariaLabel='tooltipDesc' variant='body-md-regular'>
      SMS segment - 160 characters
    </Typography>
    <Typography ariaLabel='tooltipDesc' variant='body-md-regular'>
      MMS segment - 1600 characters
    </Typography>
  </div>
)
